export const QUERY_TYPE_BADGE_CLASS = {
  REFUND: "bg-blue-100 text-blue-700",
  RESCHEDULING: "bg-yellow-100 text-yellow-700",
  CANCELLATION: "bg-red-100 text-red-700",
  BOOKING_FAILED: "bg-purple-100 text-purple-700",
};

/**
 * cancelType: 1 = full, 2 = partial (backend API contract)
 * tboCancellationType: TBO CancellationType enum — 1=NoShow, 2=FlightCancelled, 3=Others
 */
export const CANCELLATION_TYPE_SELECT = [
  { cancelType: 1, tboCancellationType: 1, label: "Passenger didn't show up (No-Show)" },
  { cancelType: 1, tboCancellationType: 2, label: "Flight cancelled by airline" },
  { cancelType: 1, tboCancellationType: 3, label: "Any other reason (Full Cancellation)" },
  { cancelType: 2, tboCancellationType: 3, label: "Partial Cancellation (Per Passenger)" },
  { cancelType: 2, tboCancellationType: 3, label: "Partial Cancellation (Per Passenger Per Sector)" },
];

// Default full-cancellation reason: TBO "Others" (3). It used to be the first
// option, No-Show (1), so an agent who left it unchanged told TBO the passenger
// did not show up even for an ordinary cancellation days before the flight.
export const DEFAULT_CANCELLATION_TYPE_LABEL = "Any other reason (Full Cancellation)";

export const REFUND_STATUS_LABELS = {
  pending_charges: "Pending TBO Verification",
  charges_quoted: "Charges Quoted",
  charges_notified: "Customer Notified",
  customer_accepted: "Customer Accepted",
  cancelled_at_airline: "Cancelled at Airline",
  refund_processed: "Refund Processed",
  abandoned: "Abandoned",
  expired: "Expired",
  blocked: "Blocked",
};

export const RESCHEDULE_STATUS_LABELS = {
  pending_flight_selection: "Flight Selected — Awaiting Fee",
  pending_fee: "Fee Set — Pending Notification",
  fee_notified: "Fee Notified to Customer",
  confirmed: "Confirmed",
  cancelled: "Cancelled",
};

/** Mirrors backend `RESCHEDULE_STATUS_TRANSITIONS`. */
export const RESCHEDULE_STATUS_TRANSITIONS = {
  null: ["pending_flight_selection", "pending_fee", "fee_notified", "confirmed", "cancelled"],
  pending_flight_selection: ["pending_fee", "cancelled"],
  pending_fee: ["fee_notified", "pending_flight_selection", "cancelled"],
  fee_notified: ["confirmed", "pending_fee", "cancelled"],
  confirmed: [],
  cancelled: ["pending_flight_selection"],
};

export const RESCHEDULE_STATUS_SELECT_ORDER = [
  "pending_flight_selection",
  "pending_fee",
  "fee_notified",
  "confirmed",
  "cancelled",
];

export const TICKET_TOP_FIELDS = [
  { key: "ticket_id", label: "Ticket ID" },
  { key: "zoho_ticket_id", label: "Zoho Reference" },
  { key: "pnr", label: "PNR" },
  { key: "customer_name", label: "Customer Name" },
  { key: "customer_email", label: "Email" },
  { key: "customer_phone", label: "Phone" },
  { key: "assignedAgent", label: "Assigned Agent" },
  { key: "created_at", label: "Created At" },
];

export function getAllowedRescheduleNextStates(currentStatus) {
  const key =
    currentStatus == null || currentStatus === "" ? "null" : String(currentStatus);
  return RESCHEDULE_STATUS_TRANSITIONS[key] ?? RESCHEDULE_STATUS_TRANSITIONS.null;
}

export function buildRescheduleProgressSteps(rescheduleStatus) {
  const rs = rescheduleStatus;
  const step1Complete = ["pending_flight_selection", "pending_fee", "fee_notified", "confirmed"].includes(rs);
  const step2Complete = ["pending_fee", "fee_notified", "confirmed"].includes(rs);
  const step3Complete = ["fee_notified", "confirmed"].includes(rs);
  const step4Complete = rs === "confirmed";
  return [
    { num: 1, label: "Pending flight selection", complete: step1Complete },
    { num: 2, label: "Pending fee", complete: step2Complete },
    { num: 3, label: "Fee notified to customer", complete: step3Complete },
    { num: 4, label: "Reschedule applied", complete: step4Complete },
  ];
}
